// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
// import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand"; // Starter Custom Code
// import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription"; // Starter Custom Code
// import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage"; // Starter Custom Code
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers"; // Starter Custom Code
// import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice"; // Starter Custom Code
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { ReactNode, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
import ProductBrand, { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { lineEllipsisStyles } from "@store/Themes/common/mixins/typography";
import { productCardProps } from "@store/Themes/common/props/productCard";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import useShowPricing from "@store/Framework/Common/Hooks/useShowPricing";
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
});

const mapDispatchToProps = {
    updateProductInfo,
};

interface OwnProps {
    carouselId: string;
    product: ProductModel;
    labelsVisible?: boolean;
    showImage: boolean;
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    extendedStyles?: ProductCarouselProductCondensedStyles;
    condensedActionsTemplate?: (product: ProductModel) => ReactNode;
    // Starter Custom Code
    showUnitOfMeasure?: boolean;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ProductCarouselProductCondensedStyles {
    container?: GridContainerProps;
    imageGridItem?: GridItemProps;
    productImageStyles?: ProductImageStyles;
    productDetailsGridItem?: GridItemProps;
    productBrandWrapper?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    productDescriptionStyles?: ProductDescriptionStyles;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    productPriceWrapper?: InjectableCss;
    productPriceStyles?: ProductPriceStyles;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    addToCartContainer?: GridContainerProps;
    qtyGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    addToCartButtonGridItem?: GridItemProps;
    productAddToCartButtonStyles?: ButtonPresentationProps;
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    condensedActionsTemplateGridItem?: GridItemProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    infosActionsWrapper?: InjectableCss;
    imageInfosWrapper?: InjectableCss;
    infosWrapper?: InjectableCss;
    attributesWrapper?: InjectableCss;
    productActionsWrapper?: InjectableCss;
    addToCartOptionsAndButton?: AddToCartOptionsAndButtonStyles;
    productAddToListWrapper?: InjectableCss;
}

export const productCarouselProductCondensedStyles: ProductCarouselProductCondensedStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            flex-grow: 1;
        `,
    },
    infosActionsWrapper: {
        css: css`
            display: flex;
            flex-grow: 1;
            column-gap: ${pxToRem(5)};
        `,
    },
    imageInfosWrapper: {
        css: css`
            display: flex;
            flex-grow: 1;
        `,
    },
    productImageStyles: mergeProps<ProductCarouselProductCondensedStyles["productImageStyles"]>(
        productCardProps.image,
        {
            wrapper: {
                css: css`
                    width: auto;
                    margin-right: ${pxToRem(10)};
                    margin-bottom: ${pxToRem(5)};
                `,
            },
            linkWrappingImage: {
                css: css`
                    max-height: ${pxToRem(65)};
                    width: ${pxToRem(65)};
                `,
            },
        },
    ),
    infosWrapper: {
        css: css`
            flex-basis: 75%;
        `,
    },
    productBrandStyles: mergeProps<ProductCarouselProductCondensedStyles["productBrandStyles"]>(
        productCardProps.brand,
        {
            wrapper: {
                css: css`
                    font-size: ${x => x.theme.design.typography.size.tiny};
                `,
            },
            nameLink: {
                typographyProps: {
                    css: css`
                        ${lineEllipsisStyles(2)}
                    `,
                },
            },
        },
    ),
    productDescriptionStyles: {
        ...productCardProps.description,
        wrapper: mergeProps(productCardProps.description?.wrapper, {
            css: css`
                ${spacingStyles(null, pxToRem(5))}
            `,
        }),
        productDetailLink: {
            css: css`
                ${lineEllipsisStyles(3)}
            `,
            typographyProps: {
                css: css`
                    vertical-align: initial;
                `,
            },
        },
    },
    attributesWrapper: productCardProps.spacingWrapper,
    productPartNumbersStyles: productCardProps.partNumbers,
    productActionsWrapper: mergeProps<ProductCarouselProductCondensedStyles["productActionsWrapper"]>(
        productCardProps.actionsWrapper,
        {
            css: css`
                width: 100%;
                margin-top: ${pxToRem(8)};
            `,
        },
    ),
    productPriceWrapper: productCardProps.spacingWrapper,
    productPriceStyles: productCardProps.price,
    productQuantityBreakPricingStyles: productCardProps.quantityBreakPricing,
    productAddToListWrapper: productCardProps.addToListWrapper,
    productAddToListLinkStyles: productCardProps.addToListLink,
    addToCartOptionsAndButton: productCardProps.addToCartOptionsAndButton,
};

const ProductCarouselProductCondensed = ({
    carouselId,
    product,
    labelsVisible,
    showImage,
    showBrand,
    showTitle,
    showPartNumbers,
    showPrice: baseShowPrice, // Store Custom Code
    showAddToCart,
    showAddToList,
    updateProductInfo,
    extendedStyles,
    productInfo,
    condensedActionsTemplate,
    // Starter Custom Code
    showUnitOfMeasure,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productCarouselProductCondensedStyles, extendedStyles));
    const showPrice = useShowPricing() && baseShowPrice; // Store Custom Code

    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };

    if (!product || !productInfo) {
        return null;
    }

    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };

    return (
        <>
            <ProductContext.Provider value={productContext}>
                <StyledWrapper {...styles.wrapper} /* Starter Custom Code */>
                    <StyledWrapper {...styles.infosActionsWrapper} /* Starter Custom Code */>
                        <StyledWrapper {...styles.imageInfosWrapper} /* Starter Custom Code */>
                            {showImage && (
                                <ProductImage
                                    // Starter Removed - showSmallImage
                                    product={productContext}
                                    extendedStyles={styles.productImageStyles}
                                    size="small" // Starter Custom Code
                                />
                            )}
                            <StyledWrapper {...styles.infosWrapper} /* Starter Custom Code */>
                                {showBrand && product.brand && (
                                    // Starter Removed - productBrandWrapper
                                    <ProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />
                                )}
                                {showTitle && (
                                    <ProductDescription
                                        product={productContext}
                                        extendedStyles={styles.productDescriptionStyles}
                                    />
                                )}
                                {showPartNumbers && (
                                    <StyledWrapper {...styles.attributesWrapper} /* Starter Custom Code */>
                                        <ProductPartNumbers
                                            productNumber={product.productNumber}
                                            customerProductNumber={product.customerProductNumber}
                                            manufacturerItem={product.manufacturerItem}
                                            showCustomerName={false}
                                            showManufacturerItem={false}
                                            showLabel={true} // Starter Custom Code
                                            extendedStyles={styles.productPartNumbersStyles}
                                        />
                                    </StyledWrapper>
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                        {/* Starter Custom Code - Start */}
                        {condensedActionsTemplate ? condensedActionsTemplate(product) : []}
                        {/* Starter Custom Code - End */}
                    </StyledWrapper>
                    {showPrice || showAddToCart /* Starter Custom Code */ ? (
                        <StyledWrapper {...styles.productActionsWrapper /* Starter Custom Code */}>
                            {showPrice && (
                                <StyledWrapper {...styles.productPriceWrapper}>
                                    {/* Starter Removed - VisuallyHidden */}
                                    <ProductPrice
                                        showLabel={false}
                                        product={productContext}
                                        extendedStyles={styles.productPriceStyles}
                                    />
                                    {/* Starter Removed - ProductUnitOfMeasureSelect */}
                                    {/* Starter Removed - ProductQuantityBreakPricing */}
                                </StyledWrapper>
                            )}
                            {showAddToCart && (
                                /* Starter Custom Code - Start */
                                <AddToCartOptionsAndButton
                                    sizeVariant={"small" as any} // Store Custom Code
                                    showUnitOfMeasure={showUnitOfMeasure}
                                    extendedStyles={{
                                        ...styles.addToCartOptionsAndButton,
                                        addToCartButton: {
                                            "data-test-selector": `addToCartBtn`,
                                        },
                                    }}
                                />
                                /* Starter Removed - ProductUnitOfMeasureSelect */
                                /* Starter Custom Code - End */
                            )}
                            {showAddToList && (
                                <StyledWrapper {...styles.productAddToListWrapper /* Starter Custom Code */}>
                                    <ProductAddToListLink
                                        data-test-selector="addToListLink"
                                        extendedStyles={styles.productAddToListLinkStyles}
                                    />
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    ) : null}
                    {/* Starter Moved - condensedActionsTemplate - up */}
                </StyledWrapper>
            </ProductContext.Provider>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCarouselProductCondensed);
